// route prefix -> Help Center chapter (first match wins — order matters)
export const HELP_MAP = [
  ["/catawiki", "catawiki"], ["/documents", "catawiki"], ["/stocktake", "stocktake"],
  ["/jewelry-stock", "jewelry"], ["/jewelry-library", "jewelry"],
  ["/jewelry", "workshop"], ["/production", "workshop"], ["/gold-stock", "workshop"],
  ["/certified", "inventory"], ["/loose", "inventory"],
  ["/purchases", "purchases"], ["/reorder", "purchases"],
  ["/sales", "sales"], ["/sold", "sales"], ["/reports", "sales"],
  ["/inquiries", "catalogue"], ["/team", "team"], ["/settings", "settings"],
];
export const helpChapterFor = (path) => (HELP_MAP.find(([p]) => path.startsWith(p)) || [null, "getting-started"])[1];
